export default function collateErrors(values, props, json) {
    const { messages } = props

    return { _error: messages.errors.global() }
}
